<template>
  <v-list-group
    id="#drawer-group" 
    v-if="link.sublinks" 
    :prepend-icon="link.icon" 
    :append-icon="link.sublinks ? '$expand' : 'false'"
    color="#fff"
  >
    <template v-slot:activator>
      <v-list-item-title v-text="link.text" />
    </template>

    <v-list-item 
      v-for="(sublink) in link.sublinks" 
      :key="sublink.text" 
      :to="sublink.to" 
      :link="true" 
      :prepend-icon="sublink.icon"
    >
      <v-list-item-icon>
        <v-icon v-text="sublink.icon" />
      </v-list-item-icon>
      <v-list-item-title v-text="sublink.text" />
    </v-list-item>
  </v-list-group>
    
  <v-list-item 
    v-else  
    :to="{
      path: link.to,
      params: {
        customerId: selectedCustomer.id,
      }
    }" 
    :link="true" 
    :prepend-icon="link.icon"  
    :key="index"
  >
    <v-list-item-icon>
      <v-icon v-text="link.icon" />
    </v-list-item-icon>
    <v-list-item-title v-text="link.text" />
  </v-list-item>
</template>

<script>
export default {
  name: "DrawerEntry",
  props: {
    link: Object,
    index: Number,
    selectedCustomer: Object,
    isLoggedIn: Boolean
  }
}
</script>

<style>
#drawer-group {
  color: white !important;
}
</style>